import { CabecalhoDeAcesso, LayoutDeAcesso } from "./layout-de-acesso";
import { FormularioDePerfil } from "./formulario-de-perfil";

/**
 * Primeiro login: antes de entrar no painel, a pessoa completa os dados de
 * contato. Aparece enquanto o perfil estiver incompleto (telefone e cargo).
 */
export function PaginaDePrimeiroAcesso({
  usuario,
}: {
  readonly usuario: { nome: string; email: string; telefone: string | null; cargo: string | null };
}) {
  const primeiroNome = usuario.nome.split(" ")[0] ?? usuario.nome;
  return (
    <LayoutDeAcesso>
      <div className="flex flex-col gap-8">
        <CabecalhoDeAcesso
          rotulo="Primeiro acesso"
          titulo={`Bem-vindo(a), ${primeiroNome}.`}
          descricao="Antes de começar, confirme seus dados. Assim a equipe Monte sabe quem é você e como falar com você."
        />
        <FormularioDePerfil
          inicial={usuario}
          textoDoBotao="Salvar e entrar no painel"
          // A sessao e recarregada ao salvar: o perfil fica completo e o painel abre.
          aoSalvar={() => undefined}
          campoGrande
        />
      </div>
    </LayoutDeAcesso>
  );
}
